import { i18n } from '@/plugins/i18n'

export const IbanInquiryStatus = {
    INVALID: 0,
    VALID:   1,
    INDETERMINATE:   2,
}

export const IbanInquiryStatusStr = {
    INVALID: i18n.t('panel.iban_inquiry_status.valid'),
    VALID:   i18n.t('panel.iban_inquiry_status.invalid'),
    INDETERMINATE:   i18n.t('panel.iban_inquiry_status.indeterminate'),

    get(iban_inquiry) {
        let iban_inquiry_str = null;

        Object.keys(ibanInquiry).forEach((item, index) => {
            if(ibanInquiry[item] === iban_inquiry) {
                iban_inquiry_str = IbanInquiryStatusStr[item];
            }
        });

        return iban_inquiry_str;
    }
}
